export function parseNumber(value: string, locale?: string): number {
  const EXAMPLE_VALUE = 1.1;
  const example = Intl.NumberFormat(locale).format(EXAMPLE_VALUE);
  const cleanPattern = new RegExp(`[^-+0-9${example.charAt(1)}]`, 'g');
  const cleaned = value.replace(cleanPattern, '');
  const normalized = cleaned.replace(example.charAt(1), '.');

  return parseFloat(normalized);
}
